import { defineStore } from 'pinia';
import type { ToastMessageOptions } from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import { ref, watch } from 'vue';


export const useAppStore = defineStore('app', () => {

  const toasts = ref<ToastMessageOptions[]>([]);

  const toast = useToast();

  watch(() => ({...toasts.value}), (newValue, oldValue) => {
    if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
      toasts.value.length && toast.add(toasts.value[toasts.value.length - 1]);
    }
  }, {deep: true});

  const addToast = (toastModel: ToastMessageOptions) => {
    toasts.value.push(toastModel);
  };

  return {
    toasts,
    addToast
  };
});
